/* eslint-disable import/prefer-default-export */
export const checkoutConfigs = [
    {
        namespace: 'reports',
        availableProductIds: [
            // Trends
            3501, 14, 15,
            // -- Goud & Zilver
            3502, 2, 3,
            // -- Groeimarkten
            3503, 5, 6,
            // -- Grondstoffen
            3504, 8, 9,
            // -- Technologie
            3505, 11, 12,
            // Trading
            37, 38, 39,
            // -- TA
            28, 29, 30,
            // -- Trading
            31, 32, 33,
            // -- Opties
            34, 35, 36,
            // Dividend
            3506, 50, 51,
            // -- Hoog Dividend
            3507, 41, 42,
            // -- Groei Dividend
            3508, 44, 45,
            // -- Turbo Dividend
            3509, 47, 48,
            // Crypto
            3510, 3387, 3388,
            // -- Crypto
            3511, 3088, 3089,
            // -- NFT
            3512, 3381, 3382,
            // -- Staking
            3538, 3539, 3540,
        ],
        selectedProductIds: [14],
        selectedDuration: { period: 12, periodType: 'Month' },
        availableGroupIds: [1, 2, 3, 4, 45],
        showMonthlySavings: true,
        headings: {
            products: '1. Kies product(en)',
            durations: '2. Looptijd abonnement',
            personalInfo: '3. Persoonlijke gegevens',
            payment: '4. Betaalwijze',
        },
        debug: true,
    },
];


export const expressCheckoutConfigs = [
    {
        namespace: 'express',
        availableProductIds: [
            // -- Groeimarkten
            3503
        ],
        selectedProductIds: [3503],
        masterCombiIds: [3503],
        selectedDuration: { period: 12, periodType: 'Month' },
        availableGroupIds: [1, 2],
        showMonthlySavings: true,
        loadingProducts: true,
        currentStep: 1,
        stepLabels: ['Looptijd', 'Gegevens', 'Betaling'],
        debug: true,
        showModal: 1,
        ctaLabel: 'Start nu',
        ctaButton: 'cta-button',
    },
];
